module.exports = __webpack_public_path__ + "img/11_83.a4dfa2fc.png";